import { IconSelectFilled, type TestProps } from '@direct-frontend/components';
import { type StepStatus as StepStatusType } from '../../lib/types';
import styles from './StepStatus.module.css';

export const StepStatus = ({
    status,
    'data-testid': dataTestId = 'StepStatus',
}: { status: StepStatusType } & TestProps) =>
    status === 'done' ? (
        <IconSelectFilled data-testid={`${dataTestId}.Done`} role="main" color="green" size="24" />
    ) : (
        <div data-testid={`${dataTestId}.Pending`} className={styles.status_progress} />
    );
